export const PILOT_MODULATORS_TABLE_FRENCH_LOCALE = {
  globalSearchPlaceholder: "Rechercher une valeur...",
  empty: "Aucun modulateurs trouvé...",
  headers: {
    serialNumber: "Numéro de série",
    acqRateInterpreted: "Taux d'acquisition",
    hwId: "Hardware Id",
    csId: "Cs Id",
    neuronId: "Neuron Id",
    localisation: "Localisation",
    siteId: "Site Id",
    typeKind: "Type",
  },
  filters: {
    placeholders: {
      serialNumber: "Rechercher par numéro de série...",
      acqRateInterpreted: "Rechercher par taux d'acquisition...",
      hwId: "Rechercher par hardware Id...",
      csId: "Rechercher par cs Id...",
      neuronId: "Rechercher par neuron Id...",
      localisation: "Rechercher par localisation...",
      siteId: "Rechercher par site Id...",
      typeKind: "Rechercher par type...",
    },
  },
};
